module.exports = __webpack_public_path__ + "img/title-frame.13f377e5.png";